import { getCurrentInstance } from 'vue';

export default function useConfirmation() {
  const instance = getCurrentInstance();
  return instance.proxy.$confirm;
}
